
export default {
  name: 'CheckoutHeaderReservationTimer',
  props: {
    isMegaMenu: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    timeLeft () {
      return this.$cart.getTimeLeft()
    },
  },

  methods: {
    gtmClick () {
      const checkoutPage = /\/(checkout)\//.test(this.$route.path)

      this.$gtm.push({ event: checkoutPage ? 'click_reservation_label_checkout' : 'click_reservation_label' })
    },
  },
}
